export default {
	UPLOADING: 'uploading',
	UPLOADED: 3,
	UPLOAD_SUCCESS: 1,
}
